import { Capacitor } from '@capacitor/core';
import React, { useEffect, useState } from 'react';
import ReCAPTCHA from "react-google-recaptcha";
import logoPng from '../../img/logo.png';
import OtpInput from '../reusableComponents/OtpInput';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import showNotification from '../../services/redux/NotifcationService';
import { useDispatch } from 'react-redux';
import { CreateStaffUser, login, resendOTP } from '../../services/redux/ApiActions';
import { Authenticate } from '../../services/redux/AuthenticationReducer';
import { LoginUser } from '../../services/redux/LoginReducer';
import bowser from 'bowser';
import ORComponent from '../Common/ORComponent';
import ResendOTPComponent from '../Common/ResendOTPComponent';
import { jwtDecode } from 'jwt-decode';

const LoginWithOTP = () => {
  const [otp, setOtp] = useState('');
  const [recaptcha, setRecaptcha] = useState('');
  const location = useLocation();
  const dispatch = useDispatch();
  const userData = location?.state?.postedData;
  const navigate = useNavigate();
  const [enableResendOTP, setEnableResendOTP] = useState(false)
  const [resendCounter, setResendCounter] = useState(30);

  useEffect(() => {
    // console.log(location?.state.phone)
    if (userData === undefined) {
      navigate(-1)
    }
  }, [navigate, userData])

  const handleSubmit = async (event) => {
    event.preventDefault();
    const data = {
      email: userData?.email,
      password: userData?.password !== null || userData?.password !== undefined ? userData?.password : '',
      code: otp,
      isOtpNeeded: true,
      recaptchaValue: recaptcha
    }
    if (userData?.email === undefined) {
      showNotification(userData?.screen === 'email' ? `Email and password are required` : 'Phone number is required', 'error');
    }
    else if (otp === '') {
      showNotification('OTP is required', 'error');
    } else if (recaptcha === undefined) {
      showNotification("Captcha verification is required", 'error');
    } else {
      const response = await dispatch(login(data));

      // Decode and validate JWT token
let decodedToken = jwtDecode(response.token_chr);
// console.log(decodedToken);

// Check token expiration
const currentTimeInSeconds = Date.now() / 1000;
if (decodedToken.exp < currentTimeInSeconds) {
  localStorage.clear();
  dispatch(Authenticate(false));
  showNotification('Session expired. Please login again.', 'error');
  navigate('/login');
  return;
}

// Extract data from decoded token claims
const userId = decodedToken["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/sid"];
const email = decodedToken["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress"];
const firstName = decodedToken["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/givenname"];
const lastName = decodedToken["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/surname"];
const phoneNumber = decodedToken["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/mobilephone"];
const roles = decodedToken["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"];

// Reconstruct user object from token claims
const userFromToken = {
  userId: userId,
  email: email,
  firstName: firstName,
  lastName: lastName,
  phoneNumber: phoneNumber,
  roles: Array.isArray(roles) ? roles : [roles],
  token_chr: response.token_chr
};

// Dispatch login with token-based user data
dispatch(LoginUser(userFromToken));

if (response && response.token_chr) {
  if (Array.isArray(userFromToken.roles)) {
    const hasOnboardingStaffRole = userFromToken.roles.includes("OnboardingStaff");
    
    if (hasOnboardingStaffRole) {
      const userAgent = window.navigator.userAgent;
      const parsedInfo = bowser.parse(userAgent);
      
      const createStaff = async () => {
        const staffData = {
          "v2pUserId": userFromToken.userId,
          "fullName": `${userFromToken.firstName} ${userFromToken.lastName}`,
          "email": userFromToken.email,
          "phone": userFromToken.phoneNumber,
          "createdBy": userFromToken.userId,
          "createdIp": "",
          "createdUserAgent": parsedInfo.browser.name
        };
        
        const staff = await dispatch(CreateStaffUser(staffData, response.token_chr));
        
        if (staff.statusCode === 200) {
          await dispatch(Authenticate(true));
          showNotification('Login Successful', 'success');
        }
      };
      
      createStaff();
    } else {
      showNotification("You are not allowed to access this section", 'error');
    }
  }
}

      // dispatch(LoginUser(response))
      // if (response) {
      //   if (response.token_chr) {
      //     if (response && response && Array.isArray(response.roles)) {
      //       const hasOnboardingStaffRole = response.roles.includes("OnboardingStaff");
      //       if (hasOnboardingStaffRole) {
      //         // console.log("User has the OnboardingStaff role.");
      //         const userAgent = window.navigator.userAgent;
      //         const parsedInfo = bowser.parse(userAgent);
      //         // console.log(parsedInfo.browser.name);
      //         const createStaff = async () => {
      //           const staffData = {
      //             "v2pUserId": response.userId,
      //             "fullName": response.firstName + " " + response.lastName,
      //             "email": response.email,
      //             "phone": response.phoneNumber,
      //             "createdBy": response.userId,
      //             "createdIp": "",
      //             "createdUserAgent": parsedInfo.browser.name
      //           }
      //           const staff = await dispatch(CreateStaffUser(staffData, response.token_chr));
      //           if (staff.statusCode === 200) {
      //             await dispatch(Authenticate(true))
      //             // const mailSentPayload = {
      //             //   "filter": "",
      //             //   "orderBy": "",
      //             //   "pageSize": 100,
      //             //   "pageNumber": 1
      //             // }
      //             // const mailSent = await dispatch(MailSentApi(mailSentPayload, response.token_chr));
      //             // if (mailSent) {
      //             //   dispatch(setMailSentData(mailSent))
      //             // }
      //           }
      //         }
      //         createStaff();
      //         // Do something if the user has the OnboardingStaff role
      //       } else {
      //         // console.log("User does not have the OnboardingStaff role.");
      //         showNotification("You are not allowed to access this section", 'error');
      //         // Do something if the user does not have the OnboardingStaff role
      //       }
      //     } else {
      //       // console.log("Response, result, or roles property is undefined or null.");
      //       // Handle the case where the response or its properties are missing
      //     }
      //   }
      // }
    }
  }
  const Resend = async (event) => {
    event.preventDefault();
    const response = await dispatch(resendOTP(userData.userId));
    if (response.statusCode === 200) {
      showNotification('OTP has been resent to your registered number and email', 'success')
      setResendCounter(30);
      setEnableResendOTP(false)
    }
  }
  const handleChange = (e) => {
    const value = e.target.value.slice(0, 6)
    const sanitizedValue = value.replace(/\D/g, '');
    setOtp(sanitizedValue);
  }

  // useEffect(() => {
  //   setInterval(() => {
  //     setEnableResendOTP(true)
  //   }, 30000);
  // }, [])

  useEffect(() => {
    const interval = setInterval(() => {
      if (resendCounter > 0) {
        setResendCounter(prevCounter => prevCounter - 1);
      } else {
        setEnableResendOTP(true)
      }
    }, 1000);

    // Clear the interval when component unmounts
    return () => clearInterval(interval);
  }, [resendCounter]);

  return (
    userData !== undefined && (
      <div className='mailsentbody'>
        <div className='logoBG'>
          <div className="rightElement">
            <div className="flex min-h-full flex-col justify-center px-6 py-10 lg:px-8">
              <div style={{ backgroundColor: `${Capacitor.isNative === true ? "transparent" : "white"}`, padding: `${Capacitor.isNative === true ? "5px" : "20px"}` }} className="rounded-lg  mt-5 sm:mx-auto sm:w-full md:max-w-md lg:max-w-lg">
                <div className="space-y-6">
                  <div>
                    <div className="sm:mx-auto sm:w-full sm:max-w-sm">
                      <img className="mx-auto h-10 w-auto" src={logoPng} alt="Your Company" />
                    </div>
                    <h2 className="pb-2 text-center text-xl font-bold leading-9 tracking-tight text-gray-900">STAFF LOGIN</h2>
                    <p className='pb-2 text-md text-center text-gray-500'>Kindly enter One Time Password
                    </p>
                    <label htmlFor="email" className="block text-md font-medium leading-6 text-gray-900">One Time Password </label>
                    <div className="mt-2">
                      <OtpInput value={otp || ''} onChange={handleChange}
                        inputStyles={{ paddingLeft: '10px', padding: '15px 10px' }} />
                    </div>
                  </div>
                  {/* <div id="captcha1" className="g-recaptcha w-full ">
   <ReCAPTCHA
     sitekey="6LcTYHIoAAAAAKc149g3Batl253-Fu5cC88frEKu"
     onChange={onChangeCaptcha}
   />
 </div> */}
                  <div className='py-4'>
                    <center><button
                      onClick={handleSubmit}
                      className="flex w-10/12 justify-center rounded-md  px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2" style={{ backgroundColor: '#2E61A2' }}>Proceed</button></center>
                  </div>
                </div>
                <ORComponent />
                <div className='flex justify-center'>
                  <button style={{ color: enableResendOTP === true ? '' : '#ccc' }} disabled={enableResendOTP === true ? false : true} onClick={Resend} className='bg-transparent'>
                    {/* <p>Resend OTP in: {resendCounter} seconds</p> */}
                    <ResendOTPComponent />
                  </button>
                </div>
                <div className='flex justify-center'>
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M10.5 1.5H8.25A2.25 2.25 0 0 0 6 3.75v16.5a2.25 2.25 0 0 0 2.25 2.25h7.5A2.25 2.25 0 0 0 18 20.25V3.75a2.25 2.25 0 0 0-2.25-2.25H13.5m-3 0V3h3V1.5m-3 0h3m-3 18.75h3" />
                  </svg>
                  <Link to="/" className=" text-base font-semibold leading-6 text-indigo-600 hover:text-indigo-500">Login with email and password</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  );
}

export default LoginWithOTP;
